import "./Input.css";

function Input ({name, label, value, onChange}) {
    return (
        <div className="form-group">
            <div className="form-head"><label for={name}>{label}</label></div>
            <div className="input"><input type="number" name={name} id={name} value={value} onChange={onChange}/></div>
        </div>
    );
}

export default Input;